var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "resend-container" },
    [
      _c(
        "el-form",
        { ref: "detailDataFormRef", attrs: { model: _vm.formData } },
        [
          _c("div", { staticStyle: { display: "flex" } }, [
            _c("div", { staticClass: "row-style" }, [
              _vm._v(" " + _vm._s(_vm.$t("mdfeTranslate.MDFEKey")) + " "),
            ]),
            _c("div", { staticClass: "airport-option" }, [
              _vm._v(" " + _vm._s(_vm.formData.mdfeKey) + " "),
            ]),
          ]),
          _c("div", { staticStyle: { display: "flex" } }, [
            _c("div", { staticClass: "row-style" }, [
              _vm._v(
                " " + _vm._s(_vm.$t("mdfeTranslate.CurrentStatusMDFe")) + " "
              ),
            ]),
            _c(
              "div",
              { staticClass: "row-label" },
              [
                _vm.formData.currentMdfeStatus === 1
                  ? _c("el-tag", { attrs: { size: "mini", type: "success" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.mdfeStatus[_vm.formData.currentMdfeStatus].label
                          ) +
                          " "
                      ),
                    ])
                  : _vm._e(),
                _vm.formData.currentMdfeStatus === 2
                  ? _c("el-tag", { attrs: { size: "mini", type: "danger" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.mdfeStatus[_vm.formData.currentMdfeStatus].label
                          ) +
                          " "
                      ),
                    ])
                  : _vm._e(),
                _vm.formData.currentMdfeStatus === 3
                  ? _c("el-tag", { attrs: { size: "mini", type: "info" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.mdfeStatus[_vm.formData.currentMdfeStatus].label
                          ) +
                          " "
                      ),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _c("div", { staticClass: "row-style" }, [
              _vm._v(" " + _vm._s(_vm.$t("mdfeTranslate.TotalWeight")) + " "),
            ]),
            _c("div", { staticClass: "airport-option" }, [
              _vm._v(" " + _vm._s(_vm.formData.totalWeight) + " "),
            ]),
          ]),
          _c("div", { staticStyle: { display: "flex" } }, [
            _c("div", { staticClass: "row-style" }, [
              _vm._v(" " + _vm._s(_vm.$t("mdfeTranslate.TargetAirline")) + " "),
            ]),
            _c("div", { staticClass: "row-label" }, [
              _vm._v(" " + _vm._s(_vm.formData.airlineName) + " "),
            ]),
            _c("div", { staticClass: "row-style" }, [
              _vm._v(
                " " + _vm._s(_vm.$t("mdfeTranslate.DepartureAirportCode")) + " "
              ),
            ]),
            _c(
              "div",
              { staticClass: "airport-option" },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("mdfeTranslate.StateOfOrigin"),
                      prop: "startState",
                      "label-position": "top",
                    },
                  },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                          clearable: "",
                          filterable: "",
                          size: "small",
                        },
                        model: {
                          value: _vm.formData.startState,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "startState", $$v)
                          },
                          expression: "formData.startState",
                        },
                      },
                      _vm._l(_vm.stateList, function (item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: { label: item.label, value: item.label },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("mdfeTranslate.departureAirport"),
                      prop: "originIata",
                      "label-position": "top",
                      rules: [
                        {
                          required: true,
                          message: _vm.$t("collectionCenter.notNull"),
                          trigger: "change",
                        },
                      ],
                    },
                  },
                  [
                    _c("ElSelectV2", {
                      staticClass: "option-style",
                      staticStyle: { width: "100%" },
                      attrs: {
                        options: _vm.airportOptions,
                        placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                        clearable: "",
                        filterable: "",
                        size: "small",
                      },
                      on: {
                        "visible-change": function (val) {
                          return _vm.getAirportOptionsChange(
                            val,
                            _vm.formData.startState
                          )
                        },
                      },
                      model: {
                        value: _vm.formData.originIata,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "originIata", $$v)
                        },
                        expression: "formData.originIata",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c("div", { staticStyle: { display: "flex" } }, [
            _c(
              "div",
              {
                staticClass: "row-style",
                staticStyle: { "border-bottom": "none" },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("mdfeTranslate.NumberOfAssociatedCTe")) +
                    " "
                ),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "row-label",
                staticStyle: { "border-bottom": "none" },
              },
              [_vm._v(" " + _vm._s(_vm.formData.cteCount) + " ")]
            ),
            _c(
              "div",
              {
                staticClass: "row-style",
                staticStyle: { "border-bottom": "none" },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("mdfeTranslate.DestinationAirportCode")) +
                    " "
                ),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "airport-option",
                staticStyle: { "border-bottom": "none" },
              },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("mdfeTranslate.DestinationState"),
                      prop: "endState",
                      "label-position": "top",
                    },
                  },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                          clearable: "",
                          filterable: "",
                          size: "small",
                        },
                        model: {
                          value: _vm.formData.endState,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "endState", $$v)
                          },
                          expression: "formData.endState",
                        },
                      },
                      _vm._l(_vm.stateList, function (item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: { label: item.label, value: item.label },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("mdfeTranslate.destinationAirport"),
                      prop: "destIata",
                      "label-position": "top",
                      rules: [
                        {
                          required: true,
                          message: _vm.$t("collectionCenter.notNull"),
                          trigger: "change",
                        },
                      ],
                    },
                  },
                  [
                    _c("ElSelectV2", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        options: _vm.airportOptions,
                        placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                        clearable: "",
                        filterable: "",
                        size: "small",
                      },
                      on: {
                        "visible-change": function (val) {
                          return _vm.getAirportOptionsChange(
                            val,
                            _vm.formData.endState
                          )
                        },
                      },
                      model: {
                        value: _vm.formData.destIata,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "destIata", $$v)
                        },
                        expression: "formData.destIata",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }